<template>
  <div class="bridge-signing-view container fluid">
    <v-card>
      <DigitalDepotDLQTable />
    </v-card>
  </div>
</template>

<script>
import DigitalDepotDLQTable from '@/components/digitalDepots/DigitalDepotDLQTable';

export default {
  name: 'DigitalDepotDLQView',
  components: {
    DigitalDepotDLQTable,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
  .bridge-signing-view {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/digitalDepots/DigitalDepotDLQView.vue